import { Button, Grid, Message } from "designSystem/index";
import React from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";

export default () => {
	return (
		<CssColumnGrid columns={1}>
			<Message
				titleText="Banner message content"
				variant="banner"
			>{{
					buttons: (
						<Grid container>
							<Grid item>
								<Button design="secondary">Button</Button>
							</Grid>
						</Grid>
					),
				}}
			</Message>
			<Message
				bulletPoints={["Banner message content", "Banner message content", "Banner message content"]}
				titleText="Title for Banner Message"
				variant="banner"
			/>
			<Message
				description="Banner message content. Banner message content. Banner message content. Banner message content. Banner message content. Banner message content. Banner message content. Banner message content. Banner message content. Banner message content. Banner message content. Banner message content."
				titleText="Title for Banner Message"
				variant="banner"
			/>
		</CssColumnGrid>
	);
};